import { Button, Form, Input, Modal } from "antd";
import { FormComponentProps } from "antd/lib/form";
import * as React from "react";
import { IPortalApplicant } from "../../../model/applicant/PortalApplicant";
import { TTranslate } from "../../../service/locale/TranslationService";

export interface State {
  searchTerms?: any;
}

export interface Props extends FormComponentProps {
  visible: boolean;
  columns: any[];
  onCancel: () => void;
  translate: TTranslate;
  setSearchApplicantInfo(searchApplicantInfo?: IPortalApplicant): void;
}

class MobileApplicantSearchModal extends React.Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = {};
  }
  renderSearchFields = () => {
    const { columns } = this.props;
    let tabs: JSX.Element[] = [];
    const { getFieldDecorator } = this.props.form;

    columns.forEach((column) => {
      tabs.push(
        <Form.Item label={column.title}>
          {getFieldDecorator(column.dataIndex as never)(<Input />)}
        </Form.Item>
      );
    });

    return tabs;
  };

  onSearch = (e) => {
    const { setSearchApplicantInfo, onCancel } = this.props;

    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        setSearchApplicantInfo(values as IPortalApplicant);
        onCancel();
        this.setState({ searchTerms: values });
      }
    });
  };

  onReset = () => {
    const { setSearchApplicantInfo, onCancel } = this.props;
    this.props.form.resetFields();
    setSearchApplicantInfo(undefined);
    onCancel();
    this.setState({ searchTerms: undefined });
  };
  render() {
    const { visible, onCancel, translate } = this.props;

    const { searchTerms } = this.state;

    return (
      <Modal
        title={translate("applicant_search_modal.title")}
        visible={visible}
        maskClosable={false}
        closable={false}
        onCancel={onCancel}
        footer={[
          <Button
            hidden={searchTerms ? false : true}
            key="reset"
            type={"danger"}
            onClick={() => this.onReset()}
          >
            {translate("applicant_search_modal.reset")}
          </Button>,
          <Button key="back" onClick={onCancel}>
            {translate("applicant_search_modal.cancel")}
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={(e) => {
              this.onSearch(e);
            }}
          >
            {translate("applicant_search_modal.search")}
          </Button>
        ]}
      >
        <Form layout="vertical">{this.renderSearchFields()}</Form>
      </Modal>
    );
  }
}

const SearchModal = Form.create<Props>({})(MobileApplicantSearchModal);

export default SearchModal;
